import { useMutation, useQueryCache } from "react-query";
import { EventParticipationAPI } from "api/eventParticipation";
import {
  CHAMPIONSHIP_PARTICIPATION,
  CHECKOUT,
  COMPETITION_EVENT,
  COMPETITION_EVENTS,
  COMPETITIONS,
  EVENT_PARTICIPATION,
  SCHEDULE,
} from "helpers/constants";
import dispatchToast from "helpers/dispatchToast";

export default function useRemoveEventParticipation() {
  const queryCache = useQueryCache();

  return useMutation(EventParticipationAPI.removeEventParticipation, {
    onSuccess: ({ message }) => {
      queryCache.invalidateQueries(CHAMPIONSHIP_PARTICIPATION);
      queryCache.invalidateQueries(CHECKOUT);
      queryCache.invalidateQueries(COMPETITION_EVENT);
      queryCache.invalidateQueries(COMPETITION_EVENTS);
      queryCache.invalidateQueries(COMPETITIONS);
      queryCache.invalidateQueries(EVENT_PARTICIPATION);
      queryCache.invalidateQueries(SCHEDULE);
      dispatchToast({ message, type: "success" });
    },
  });
}
